import { memo, useEffect, useState } from "react";
import styles from "./EpollAnswers.module.css";
import Highlight from "../Highlight/Highlight";
import { Checkbox, Tag } from "antd";

const EpollQuestionAnswer = ({
  questionAnswer,
  highlightedText,
  answersChecked,
  addCheck,
  removeCheck,
  hasChecked,
  types,
  showTypes,
  addingId,
}) => {
  let highlightArray = null;
  const removeFromArray = (el) => {
    const index = highlightArray.indexOf(el);
    if (index > -1) {
      // only splice array when item is found
      highlightArray.splice(index, 1);
    }
  };
  if (highlightedText != null && !Array.isArray(highlightedText)) {
    highlightArray = [highlightedText];
  }
  if (highlightedText != null && Array.isArray(highlightedText)) {
    highlightArray = [...highlightedText];
    for (let i = 0; i < highlightedText.length; i++) {
      const a = `${highlightedText[i]}`.trim();
      for (let j = i + 1; j < highlightedText.length; j++) {
        const b = `${highlightedText[j]}`.trim();
        if (a.includes(b) && a !== b && a.length > b.length) {
          removeFromArray(highlightedText[j]);
        } else if (b.includes(a) && b.length >= a.length) {
          removeFromArray(highlightedText[i]);
        }
      }
    }
    highlightArray = highlightArray.map((el) => {
      if (el.includes(questionAnswer.answer)) {
        return questionAnswer.answer;
      }

      return el;
    });
    if (questionAnswer.answer && Array.isArray(highlightArray)) {
      if (
        highlightArray.join(" ").trim().replace(/\s\s+/g, " ") ===
        `${questionAnswer.answer}`.trim().replace(/\s\s+/g, " ")
      ) {
        highlightArray = questionAnswer.answer.split(" ");
      }
    }

    // console.log(highlightArray);
  }
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (answersChecked) {
      if (Array.isArray(answersChecked)) {
        for (let index = 0; index < answersChecked.length; index++) {
          const element = answersChecked[index];
          if (addingId == element) {
            setChecked(true);
            // console.log(element)
            break;
          } else {
            setChecked(false);
          }
        }
      }
    }
  }, [addingId, answersChecked]);
  useEffect(() => {
    hasChecked(checked);
  }, [checked]);
  return (
    <div className={styles.EpollQuestionContainer}>
      <div
        className={styles.RightSide}
        style={{ textDecoration: checked ? "line-through" : "none" }}
      >
        <Checkbox
          checked={checked}
          onChange={(e) => {
            if (e.target.checked) {
              addCheck(addingId, () => {
                setChecked(true);
              });
            } else {
              removeCheck(addingId, () => {
                setChecked(false);
              });
            }
          }}
          disabled={addingId ? false : true}
        />
        <div className={styles.EpollQuestionAnswer}>
          <span unselectable="on" className={styles.Question}>
            {questionAnswer.question}:{" "}
          </span>
          <b>
            <Highlight tags={highlightArray}>{questionAnswer.answer}</Highlight>
          </b>
        </div>
      </div>
      {showTypes && Array.isArray(types) && (
        <div className={styles.Types}>
          {types.map((el) => {
            return (
              el && (
                <Tag color="blue" key={el.id}>
                  {el.title}
                </Tag>
              )
            );
          })}
        </div>
      )}
    </div>
  );
};

export default memo(EpollQuestionAnswer);
